<template>
  <!-- Estrutura item -->
  <div class="block-item block">
    <b-row class="mx-auto">
      <h6>
        {{ item.edition_type_name }} &numero; {{ item.edition_number }} - Página
        {{ item.page_number }}
      </h6>
      <div class="item-actions">
        <b-link
          v-if="pdfJsExpressKey"
          class="d-inline"
          @click.prevent="preparePDF(item.edition_id, item.page_number)"
          href="#loadPDF"
          v-b-tooltip.hover
          title="Acessar página encontrada"
        >
          <icon name="file-pdf"></icon>
          <span> Página Encontrada </span>
        </b-link>
        <b-link
          v-else
          class="d-inline"
          target="_blank"
          :href="downloadPage(item.edition_id, item.page_number)"
          v-b-tooltip.hover
          title="Baixar página encontrada"
        >
          <icon name="download"></icon>
          <span> Página Encontrada </span>
        </b-link>
        &nbsp;
        <b-link
          class="d-inline"
          :href="downloadEdition(item.edition_id)"
          v-b-tooltip.hover
          title="Baixar edição"
        >
          <icon name="download"></icon>
          <span> Edição Completa </span>
        </b-link>
      </div>
    </b-row>
    <b-row class="mx-auto mb-2">
      <span class="item-data"> {{ item.publication_date | formatDate }}</span>
    </b-row>
    <b-row class="mx-auto">
      <p
        class="item-result"
        v-html="
          item.highlight[0]
            .replace(/<em>/g, '<strong>')
            .replace(/<\\\/em>/g, '</strong>')
        "
      ></p>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import 'moment/locale/pt-br'

  export default {
    name: 'BuscaItem',
    props: {
      item: Object,
      result: String
    },
    data() {
      return {}
    },
    methods: {
      downloadEdition(editionId) {
        return axios.defaults.baseURL + '/editions/downloadPdf/' + editionId
      },
      downloadPage(editionId, pageNumber) {
        return (
          axios.defaults.baseURL +
          '/editions/viewPdf/' +
          editionId +
          '#page=' +
          pageNumber +
          '&search="' +
          this.result +
          '"'
        )
      },
      preparePDF(editionID, pageNum) {
        const searchTerm = this.result
        const pathUrl = `${axios.defaults.baseURL}/editions/viewPdf/${editionID}`

        window.localStorage.setItem('pathUrl', pathUrl)
        window.localStorage.setItem('searchTerm', searchTerm)
        window.localStorage.setItem('pageNum', pageNum.toString())

        window.open(
          `../../#/ver-edicao?file=${encodeURIComponent(
            pathUrl
          )}&page=${pageNum}&searchTerm=${searchTerm}`,
          '_blank'
        )
      }
    },
    computed: {
      pdfJsExpressKey() {
        return process.env.PDFJSEXPRESS_LICENCE_KEY
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('LL')
        }

        return '-'
      },
      formatHL: function (value) {
        let ret = value[0]
          .replace('<em>', '<strong>')
          .replace('<\\/em>', '</strong>')
        return ret
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/estilos.scss';
  .block-item {
    margin-bottom: 1rem;
    h6 {
      font-size: 16px;
      font-weight: normal;
      color: $corPrimaria;
      margin-bottom: 0;
    }
    .item-actions {
      margin-left: auto;
      a {
        color: $corFontePadrao;
        &:hover .fa-icon {
          color: $corPrimariaClara;
        }
        .fa-icon {
          margin-bottom: -4px;
        }
        span {
          font-size: 13px;
          color: $corTextoInput;
        }
      }
    }
    .item-data {
      color: #666666;
      font-size: 13px;
      font-style: italic;
    }
    p.item-result {
      font-size: 13px !important;
      font-style: normal !important;
    }
  }
  /* Media Queries */
  /* xs and sm */
  @media (max-width: 767.98px) {
    .block-item {
      .item-actions {
        margin: 0.5rem auto 0.5rem 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BuscaItem.vue